export default __webpack_public_path__ + "726823d7d0e77782c65eb769a739e676.svg";